// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const transition: Styleguide["transition"] = {};

export default transition;
